<template>
    <div>

        <label
            v-if="label"
            class="select-none"
        >{{ label }}</label>
        <select
            ref="input"
            :class="inputClasses"
            :disabled="disabled"
            :tabIndex="tabIndex"
            @change="handleSelect($event)"
            @keyup.enter="handleEnter"
        >
            <option
                :selected="isEmpty"
                hidden
                disabled
                value
            />
            <option
                v-for="(option, index) in options"
                :key="index"
                :value="option.id"
                :selected="value === option.id"
            >
                {{ option.name }}
            </option>
        </select>

        <transition name="fade">
            <div
                v-if="invalid"
                class="text-sm mt-2 text-red-light"
            >
                <slot name="errors" />
            </div>
        </transition>

    </div>
</template>
 
<script>
export default {

    props: {
        label: {
            type: String,
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
        size: {
            type: String,
            default: null,
        },
        value: {
            type: [Number, String],
            default: null,
        },
        canBeTabbedTo: {
            type: Boolean,
            default: true,
        },
        focused: {
            type: Boolean,
            default: false,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        isEmpty() {
            return !this.value;
        },
        tabIndex() {
            return this.canBeTabbedTo ? '0' : '-1';
        },
        inputClasses() {
            let classes = '';
            if (!this.isEmpty) {
                classes += ' not-empty';
            }
            if (this.invalid) {
                classes += ' invalid';
            }
            if (this.size === 'small') {
                classes += ' p-2 text-sm';
            } else {
                classes += ' p-3';
            }
            return classes;
        },
    },

    watch: {
        focused(newValue) {
            if (newValue) {
                this.focusInput();
            }
        },
    },

    mounted() {
        if (this.focused) {
            this.focusInput();
        }
    },

    methods: {
        handleSelect(event) {
            this.$emit('input', parseInt(event.target.value, 10));
        },
        handleEnter() {
            this.$emit('enter');
        },
        focusInput() {
            this.$nextTick(() => this.$refs.input.focus());
        },
    },

};
</script>

<style lang="scss" scoped>
label {
    @apply block text-xs uppercase tracking-wide font-semibold text-grey-darker mb-1;
}
select {
    border: 2px solid;
    @apply bg-grey-lighter rounded border-grey-lighter transition-fast w-full px-3 py-0;
    height: 2.75rem;
    &:focus,
    &.not-empty {
        @apply border-primary outline-none;
    }
    &.invalid {
        @apply border-red-light;
    }
    &::placeholder {
        @apply text-sm text-grey opacity-100;
    }
}
.fade-enter-active,
.fade-leave-active {
    @apply transition-slow;
}
.fade-enter,
.fade-leave-to {
    @apply opacity-0;
    transform: translateX(10px);
}
</style>
